import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Guid } from '@fitscovery/common/types';
import { CreateMemberInfo, GetEventActiveMembersResponse, MemberCreateResponse, Membership, MembershipSubscription, MembershipSubscriptionResponse, MembershipSubscriptionWithPMSEmailTemplate, MembershipSubscriptionWithPMSEmailTemplateCreateResponse, MembershipWithHistory } from '../models';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';
import { map } from 'rxjs/operators';

@Injectable()
export class ApiMembershipService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) { }

  importMembers(formData: FormData): Observable<any> {
    return this.http.post(`${this.env.azureFunctionsApi.memberships}/memberships/import-members`, formData);
  }

  createMember(member: CreateMemberInfo): Observable<MemberCreateResponse> {
    return <Observable<MemberCreateResponse>>this.http.post(`${this.env.azureFunctionsApi.memberships}/memberships/create-user-and-membership`, member);
  }

  archiveMember(member: Membership): Observable<Membership> {
    return <Observable<Membership>>this.http.put(`${this.env.azureFunctionsApi.memberships}/memberships/${member.id}/archive`, member);
  }

  updateMember(member: Membership): Observable<Membership> {
    return <Observable<Membership>>this.http.put(`${this.env.azureFunctionsApi.memberships}/memberships/${member.id}`, member);
  }

  stopMembershipRecurring(membership: Membership): Observable<Membership> {
    return <Observable<Membership>>this.http.put(`${this.env.azureFunctionsApi.memberships}/memberships/${membership.id}/update-recurring`, {
      membershipId: membership.id,
      memberId: membership.memberId,
      partnerId: membership.partnerId,
      isRecurring: membership.isRecurring,
    }).pipe(
      map(() => {
        return membership;
      }),
    );
  }

  getMembersByPartnerId(partnerId: Guid): Observable<Membership[]> {
    return <Observable<Membership[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/memberships/partners/${partnerId}`);
  }

  getMembershipWithHistory(membershipId: Guid, partnerId: Guid): Observable<MembershipWithHistory[]> {
    return <Observable<MembershipWithHistory[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/memberships/${membershipId}/partners/${partnerId}`);
  }

  createMembershipSubscription(membershipSubscription: MembershipSubscription): Observable<MembershipSubscriptionResponse> {
    return <Observable<MembershipSubscriptionResponse>>this.http.post(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscriptions/create-partner-membership-subscriptions`, membershipSubscription);
  }

  updateMembershipSubscription(membershipSubscription: MembershipSubscription): Observable<MembershipSubscription> {
    return <Observable<MembershipSubscription>>this.http.put(`${this.env.azureFunctionsApi.memberships}/partner-memberships-subsriptions/${membershipSubscription.id}`, membershipSubscription);
  }

  deleteMembershipSubscription(membershipSubscriptionId: string): Observable<any> {
    return this.http.delete(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscriptions/${membershipSubscriptionId}`);
  }

  getMembershipSubscriptionById(id: Guid): Observable<MembershipSubscriptionResponse> {
    return <Observable<MembershipSubscriptionResponse>>this.http.get(`${this.env.azureFunctionsApi.memberships}/membership/partner-membership-subscription/${id}`);
  }

  getMembershipSubscriptionsByPartnerId(partnerId: Guid): Observable<MembershipSubscription[]> {
    return <Observable<MembershipSubscription[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/memberships/partners/${partnerId}/subscriptions`);
  }

  setMembershipSubscriptionOrder(id: Guid, partnerId: Guid, orderNumber: number): Observable<any> {
    return <Observable<MembershipSubscription[]>>this.http.put(`${this.env.azureFunctionsApi.memberships}/partner-memberships-subscriptions/${id}/order-number`, {
      id, partnerId, orderNumber
    });
  }
  
  createMembershipSubscriptionWithPMSEmailTemplate(membershipSubscriptionWithPMSEmailTemplate: MembershipSubscriptionWithPMSEmailTemplate): Observable<MembershipSubscriptionWithPMSEmailTemplateCreateResponse> {
    console.log(membershipSubscriptionWithPMSEmailTemplate);
    return <Observable<MembershipSubscriptionWithPMSEmailTemplateCreateResponse>>this.http.post(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription/create-with-pms-email-template`, membershipSubscriptionWithPMSEmailTemplate);
  }
  updateMembershipSubscriptionWithPMSEmailTemplate(membershipSubscriptionWithPMSEmailTemplate: MembershipSubscriptionWithPMSEmailTemplate): Observable<MembershipSubscription> {
    return <Observable<MembershipSubscription>>this.http.put(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscriptions/with-pms-email-template/${membershipSubscriptionWithPMSEmailTemplate.id}`, membershipSubscriptionWithPMSEmailTemplate);
  }

  getEventActiveMembers(partnerId: Guid, eventStart: Date, numberOfTicket: number): Observable<GetEventActiveMembersResponse> {
    return this.http.post<GetEventActiveMembersResponse>(`${this.env.azureFunctionsApi.memberships}/members/partners/${partnerId}/status-active`, {
      partnerId, eventStart, numberOfTicket
    });
  }

}
